import React from 'react';
import { Link } from 'react-router-dom';
import { toast as sonnerToast } from 'sonner';
import { all_routes } from '../../../core/data/routes/all_routes';
import { PendingPaymentToastProps } from '../../../core/Interface/elements/notificationInterface';

/**
 * @component PendingPaymentToast
 * @description Component that displays a toast notification for pending payments that require activation.
 * It presents different layouts depending on the device (mobile or desktop).
 *
 * @example
 * // Usage example
 * <PendingPaymentToast
 *   Indicates if the device is desktop (true) or mobile (false)
 *   payment={paymentData}
 *   Unique identifier for the toast to be able to close it
 *   isDesktop={true}
 *   toastId="payment-123"
 *   Function that formats a date string to a long format in Spanish
 *   formatDateToLongSpanish={formatDateFunction}
 * />
 */
const PendingPaymentToast: React.FC<PendingPaymentToastProps> = ({
  payment,
  isDesktop,
  toastId,
  formatDateToLongSpanish
}) => {
  return (
    <div className="w-100" style={{ minWidth: '300px', width: '100%' }}>
      <div className="d-flex justify-content-between align-items-center">
        {isDesktop ? (
          <h5>¡No olvides activar tus clases!</h5>
        ) : (
          <h5>{payment.description} ¡Actívalo ya!</h5>
        )}
        <button
          className="btn btn-sm btn-light text-danger py-0 d-none d-md-block"
          onClick={() => sonnerToast.dismiss(toastId)}
          style={{ border: 'none', background: 'transparent', fontSize: '1.5rem', lineHeight: '1' }}
        >
          <span className="d-flex mb-1">
            &times;
          </span>
        </button>
        <div style={{ display: "contents" }} className="mt-2 text-end d-md-none">
          <Link
            to={all_routes.paymentsDetails + "#customer-content"}
            className="btn btn-primary btn-sm"
            style={{ textDecoration: 'none' }}
          >
            Activar Paquete
          </Link>
        </div>
      </div>
      <p className="mb-0 d-none d-md-block"><strong>Paquete:</strong> {payment.description}</p>
      <p className="mb-0 d-none d-md-block"><strong>Fecha de compra:</strong> {formatDateToLongSpanish(payment.paymentDate)}</p>
      <div className="mt-2 text-end">
        <Link
          to={all_routes.paymentsDetails + "#customer-content"}
          className="btn btn-primary btn-sm d-none d-md-block"
          style={{ textDecoration: 'none' }}
        >
          Activar Paquete
        </Link>
      </div>
    </div>
  );
};

export default PendingPaymentToast;